import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ChevronRight from '@mui/icons-material/ChevronRight';
import './CommunityBreadcrumb.css';

const TXT_BREADCRUMB = { fr: 'Fil d\'Ariane', en: 'Breadcrumb', de: 'Brotkrümelnavigation', es: 'Ruta de navegación', pt: 'Trilha de navegação' };

/** @param {{ crumbs: { label: string, to?: string }[], className?: string }} props */
export default function CommunityBreadcrumb({ crumbs, className = '' }) {
    const { lang } = useParams();
    if (!crumbs?.length) return null;
    const [first, ...rest] = crumbs;
    return (
        <nav className={`community-heading-trail${className ? ` ${className}` : ''}`} aria-label={TXT_BREADCRUMB[lang] || TXT_BREADCRUMB.en}>
            {first.to ? (
                <Link className="community-heading-trail__link" to={first.to}>
                    <h1>{first.label}</h1>
                </Link>
            ) : (
                <h1>{first.label}</h1>
            )}
            {rest.map((c, idx) => {
                const isLast = idx === rest.length - 1;
                return (
                    <React.Fragment key={`${idx}-${c.label}`}>
                        <span className="community-heading-trail__chev" aria-hidden>
                            <ChevronRight className="community-heading-trail__chev-icon" fontSize="inherit" />
                        </span>
                        {c.to ? (
                            <Link className="community-heading-trail__link" to={c.to}>
                                <h2>{c.label}</h2>
                            </Link>
                        ) : (
                            <h2 aria-current={isLast ? 'page' : undefined}>{c.label}</h2>
                        )}
                    </React.Fragment>
                );
            })}
        </nav>
    );
}
